module.exports = __webpack_public_path__ + "static/smartly_io-64a511af44e51c9ce6f9ccf0a2b5e158.svg";